var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-field" },
        [
          _c(
            "b-dropdown",
            {
              key: "dropdown-" + _vm.updateKey,
              attrs: { text: _vm.pages[_vm.term] }
            },
            _vm._l(_vm.pages, function(name, i) {
              return _c(
                "b-dropdown-item",
                {
                  key: _vm.index,
                  on: {
                    click: function($event) {
                      return _vm.setPage(i)
                    }
                  }
                },
                [_vm._v(_vm._s(name))]
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("layout-14", {
        key: _vm.updateKey,
        staticStyle: { height: "calc(100vh - 110px)" },
        attrs: {
          term: _vm.term,
          page: _vm.pageIds[_vm.term],
          roleEditPage: _vm.roleEditPageId
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b9cd7e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b9cd7e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file/Permissions.vue
// module id = 512
// module chunks = 0